
import { Component, Vue } from 'vue-property-decorator';
import OsCard from '@/components/core/card/OsCard.vue';
@Component({
  components: { OsCard }
})
export default class OsProfileIconPopover extends Vue {
  menu = false;

  async logout() {
    await this.$store.dispatch('auth/logout');
    await this.$router.push('/');
  }
}
